if(!customElements.get('instant-update-product-info')) {
    class InstantUpdateProductInfo extends HTMLElement {
        constructor() {
            super();
            this.productVariants = [];
            this.selectedOptionsValue = [];
            this.selectedOptionsValue = [];
        }
        connectedCallback() {
            this.selectors = {
                inputSizes: document.querySelectorAll('.product-form__input[data-option-handle=size] > input, .product-form__input[data-option-handle=style] > input'),
                price: document.querySelector('.price__container .price__regular .price-item--regular'),
                nameId: document.querySelector('.product-variant-id'),
                styleLabel: document.querySelector('fieldset[data-option-handle="style"] .form__label')
            }
            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueSelectionChange,
                this.handleOptionValueChange.bind(this)
            );
            this.getProductDetails(this.dataset.handle);
        }
        async getProductDetails(handle) {
            await fetch(`/products/${handle}.json`)
            .then(response => response.json())
            .then(data => {
                this.productVariants = data?.product?.variants;
            })
            .catch(error => {
                console.log(error);
            });
        }
        handleOptionValueChange(event) {
           const matchedVariant = this.productVariants.find(variant => {
                const parts = variant.title.split('/').map(p => p.trim().toLowerCase());
                return event.data.selectedOptionsValue.every((value, index) => {
                    const safeValue = value.toLowerCase().trim();
                    const part = parts[index];
                    return safeValue === part;
                });
           });

           if (matchedVariant) {
                const url = new URL(window.location.href);
                url.searchParams.set('variant', matchedVariant.id);
                window.history.replaceState({}, '', url);
                this.selectors.nameId && (this.selectors.nameId.value = matchedVariant.id);
                this.selectors.price && (this.selectors.price.textContent = `${this.dataset.currency}${matchedVariant.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`);
                this.selectors.styleLabel && (this.selectors.styleLabel.innerHTML = `<p><strong>Style:</strong> ${matchedVariant.option3}</p>`);
                publish(PUB_SUB_EVENTS.variantSelectedChanged, {
                    data: {
                        variant: matchedVariant
                    },
                });
           }
           if(!event.data.target.closest('[data-option-handle="frame-type"]')) return;

           this.selectedOptionsValue = event.data.selectedOptionsValue;
           const selectedSizes = this.productVariants.filter(variant => 
                variant.title.includes(event.data.target.value)
           );
           Array.from(this.selectors.inputSizes).forEach(input => {
                // Get the matched size object
                const matchedSize = selectedSizes.find(size => size.option2 === input.value || size.option3 === input.value);
                if (matchedSize) {
                    input.classList.remove('disabled');
                    input.disabled = false;
                } else {
                    input.classList.add('disabled');
                    input.disabled = true;
                }
           });
           publish(PUB_SUB_EVENTS.variantOptionsSortingChanged, {
              data: {
                event,
                updateInfo: event.data.target.closest('[data-option-handle="frame-type"]'),
                selectedOptionsValue: this.selectedOptionsValue
              },
           });  
        }

    }
    customElements.define('instant-update-product-info', InstantUpdateProductInfo)
}